import { currencyFormat } from 'common/helpers/numberHelper';

import ModifierPrice from './itemPrice/ModifierPrice';

const ItemPrice = (props) => {
  const { item, settings } = props;
  const { modifiers } = item;

  if (item.purchaseType === 'Pickup To Ship') {
    return (
      <div className="c7-cart-items__price" aria-label="Unit price">
        -
      </div>
    );
  }

  if (
    modifiers &&
    modifiers.priceBeforeModifiers !== modifiers.comparePriceBeforeModifiers
  ) {
    return (
      <div className="c7-cart-items__price" aria-label="Unit price">
        <span>
          {currencyFormat(modifiers.comparePriceBeforeModifiers, settings)}
        </span>
        <br />
        {currencyFormat(modifiers.priceBeforeModifiers, settings)}
        <Points item={item} />
        <br />
        <ModifierPrice item={item} settings={settings} />
      </div>
    );
  }

  if (item.modifiers) {
    return (
      <div className="c7-cart-items__price" aria-label="Unit price">
        {currencyFormat(modifiers.comparePriceBeforeModifiers, settings)}
        <Points item={item} />
        <br />
        <ModifierPrice item={item} settings={settings} />
      </div>
    );
  }

  if (item.comparePrice > item.price) {
    return (
      <div className="c7-cart-items__price" aria-label="Unit price">
        <span>{currencyFormat(item.comparePrice, settings)}</span>
        <br />
        {currencyFormat(item.price, settings)}
        <Points item={item} />
      </div>
    );
  }

  return (
    <div className="c7-cart-items__price" aria-label="Unit price">
      {currencyFormat(item.price, settings)}
      <Points item={item} />
    </div>
  );
};

const Points = (props) => {
  const { item } = props;
  if (item.itemData?.loyaltyPoints) {
    return (
      <>
        <br />
        {item.itemData.loyaltyPoints} Points
      </>
    );
  }
  return null;
};

export default ItemPrice;
